import { render, staticRenderFns } from "./ControlsBlockTool.vue?vue&type=template&id=6cc12f3a&scoped=true&lang=pug&"
import script from "./ControlsBlockTool.vue?vue&type=script&lang=js&"
export * from "./ControlsBlockTool.vue?vue&type=script&lang=js&"
import style0 from "./ControlsBlockTool.vue?vue&type=style&index=0&id=6cc12f3a&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc12f3a",
  null
  
)

export default component.exports